<div class="app-container">
  <!-- Banner di test per ambiente di test -->
  <div *ngIf="isTestEnvironment" class="test-environment-banner">
          <div class="test-banner-content">
        <span class="test-icon">⚠️</span>
        <span class="test-text">AMBIENTE DI {{ environment.name }} [con dati aggiornati al 01/09/2025]</span>
        <span class="test-icon">⚠️</span>
      </div>
  </div>

  <header>
    <nav-bar *ngIf="showNavBar"></nav-bar>
  </header>
  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
  <footer class="app-footer">
    <app-footer></app-footer>
  </footer>
</div>
